module.exports = __webpack_public_path__ + "static/img/Bachelor_010259.882f63d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010259.jpg
// module id = 131
// module chunks = 0